export function getTileUrl(): string {
  if (process.env.REACT_APP_OFFLINE_MODE === 'true') {
    return '/tiles/{z}/{x}/{y}.png';
  }
  return 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
}

export function getTileAttribution(): string {
  return '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
}
